import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRiskScore = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M12.58 10.885a.48.48 0 0 1 .536.126l.016.007.03.045a.466.466 0 0 1-.073.6l-2.904 2.692-.015.015-.019.01a1.22 1.22 0 0 1-1.654-.393 1.16 1.16 0 0 1 .396-1.621l.01-.005.008-.004.035-.016.01-.004.207-.084h.001l3.415-1.37v.002Zm-3.847 3.092.007.007a1 1 0 0 1-.074-.102zM7.365 9.08c-1.384.84-2.32 2.322-2.364 4.02h-3.3c0-2.92 1.581-5.474 3.956-6.9zm6.991-2.885c2.38 1.424 3.966 3.984 3.966 6.905h-3.3c-.045-1.7-.981-3.187-2.373-4.025zM10.011 5c1.41 0 2.728.338 3.887.938l-1.71 2.89a5.1 5.1 0 0 0-2.178-.486c-.781 0-1.525.175-2.185.489L6.116 5.944A8.45 8.45 0 0 1 10.011 5" />
  </svg>
);
export default SvgRiskScore;
